import React from 'react'
import { useSelector } from 'react-redux'
import { PropTypes } from 'prop-types'
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from '../../../../components/mui/Core/index'
import {
  getCurrencyFormattedValue,
  getDateFormattedValue,
  getDateTimeFormattedValue,
  getTimeFormattedValue,
} from '../../../../utils/string-utils'
import Constants from '../../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../../constants/session-storage-key-constants'
import CopyContentButton from '../../../../components/genericcomponents/CopyContentButton/copy-content-button'

function ShippingDetailsCard({ orderDetails }) {
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const dmsUser = selectedClient?.dmsFlag || authenticatedUser?.dms
  const carrier = orderDetails?.carrierService
  const createdOn = orderDetails?.createdOn
  const shipName = orderDetails?.shipToName
  const shipCustomerNumber = orderDetails?.shipToCustNum
  const shippingAddress1 = orderDetails?.shipAddr1
  const shippingAddress2 = orderDetails?.shipAddr2
  const shippingAddress3 = orderDetails?.shipAddr3
  const shipCity = orderDetails?.shipCity
  const shipState = orderDetails?.shipState
  const shipZipcode = orderDetails?.shipZip
  const shipToPO = orderDetails?.shipPO || Constants.orderAllocations.NONE
  const shipDate = getDateTimeFormattedValue(orderDetails?.dateShipped)
  const wmsOrderValue = getCurrencyFormattedValue(orderDetails?.shipmentValue)
  const shipEmailAddress = orderDetails?.shipEmailAddress
  const contactEmail = `${Constants.orders.order_details.CONTACT_EMAIL}`
  const cardStyle = { height: '100%' }
  const headerStyle = { py: 3 }
  const bodyStyle = { py: 2 }
  const smallTopMarginStyle = { mt: 1.5 }
  const mediumTopMarginStyle = { mt: 2 }
  const shipEmailStyle = { wordBreak: 'break-word' }

  return (
    <Card variant='outlined' sx={cardStyle}>
      <CardContent sx={headerStyle}>
        <Typography variant='h6'>{Constants.orders.order_details.SHIPPING_DETAILS}</Typography>
      </CardContent>
      <Divider />
      <CardContent sx={bodyStyle}>
        <Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.SHIP_TO_NAME}</Typography>
              <Typography variant='body1'>{shipName}</Typography>
              <Typography variant='body1'>{shipCustomerNumber}</Typography>
            </Grid>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.PO_NUMBER}</Typography>
              <Typography variant='body1'>{shipToPO}</Typography>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <CopyContentButton content={shipEmailAddress} headerName={contactEmail} />
              <Typography variant='body1' sx={shipEmailStyle}>
                {shipEmailAddress || Constants.orderAllocations.NONE}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={mediumTopMarginStyle}>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.SHIP_TO_ADDRESS}</Typography>
              {shippingAddress1 && <Typography variant='body1'>{shippingAddress1}</Typography>}
              {shippingAddress1 !== 'Redacted' && shippingAddress2 && (
                <Typography variant='body1'>{shippingAddress2}</Typography>
              )}
              {shippingAddress1 !== 'Redacted' && shippingAddress3 && (
                <Typography variant='body1'>{shippingAddress3}</Typography>
              )}
              {shippingAddress1 !== 'Redacted' && (
                <Typography variant='body1'>
                  {shipCity}, {shipState} {shipZipcode}
                </Typography>
              )}
            </Grid>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.CREATED_ON}</Typography>
              <Typography variant='body1'>{getDateFormattedValue(createdOn)},</Typography>
              <Typography variant='body1'>{getTimeFormattedValue(createdOn)}</Typography>
            </Grid>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.DATE_SHIPPED}</Typography>
              <Typography variant='body1'>
                {(getDateFormattedValue(shipDate) && `${getDateFormattedValue(shipDate)},`) ||
                  `${Constants.orders.order_details.PENDING}`}
              </Typography>
              <Typography variant='body1'>{getTimeFormattedValue(shipDate)}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={mediumTopMarginStyle}>
            <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
              <Typography variant='h6'>{Constants.orders.order_details.CARRIER_SERVICE}</Typography>
              {carrier && <Typography variant='body1'>{carrier}</Typography>}
            </Grid>
            {dmsUser === 'Y' && (
              <Grid size={{ xs: 4 }} sx={smallTopMarginStyle}>
                <Typography variant='h6'>
                  {Constants.orders.order_details.SHIPMENT_VALUE}
                </Typography>
                <Typography variant='body1'>{wmsOrderValue}</Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  )
}

ShippingDetailsCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  orderDetails: PropTypes.any.isRequired,
}

export default ShippingDetailsCard
